













 


















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHighlighted"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskId"
},
v3 = {
  "kind": "Variable",
  "name": "meetingId",
  "variableName": "meetingId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "isHighlighted",
    "variableName": "isHighlighted"
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "taskId",
    "variableName": "taskId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v3/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "isHighlighted",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SetTaskHighlightSuccess",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SetTaskHighlightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "setTaskHighlight",
        "plural": false,
        "selections": [
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SetTaskHighlightMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "setTaskHighlight",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_EEKAMQtY2W7CBeM-ww5A0A",
    "metadata": {},
    "name": "SetTaskHighlightMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "6acc093b17ed60e84eabcfce9947967e";

export default node;
